import MuiTabs from '@mui/material/Tabs';
import { styled } from '@mui/system';
import colors from '../../../assets/colors';

const Tabs = styled(MuiTabs, {
  shouldForwardProp: (prop) => prop !== 'underlined',
})(({ theme, underlined }) => ({
  borderBottom: `1px solid ${colors.oldAgroweGreen}`,
  boxShadow: `inset 0 0 10px 1px #00000020`,
  '.MuiTabs-indicator': {
    backgroundColor: colors.white,
    display: 'none',
    ...(underlined && { display: true }),
  },
  '.MuiTabs-scrollButtons': {
    color: colors.white,
  },
  '.MuiTabScrollButton-root': {
    boxShadow: `inset 0 0 10px 1px #00000020`,
  },
  '.MuiTabs-root': {
    boxShadow: `inset 0 0 10px 1px #00000020`,
  },
}));

export default Tabs;
